import * as Yup from 'yup';

import { Form, Formik } from 'formik';
import {
  InputForm,
  InputFormLarge,
  InputPhone,
  Label,
  NextBtn,
  RightInputWrapper,
  Sublabel,
  TextareaForm,
  TwoInputWrapper,
} from 'src/components/Form/elements';
import React from 'react';

import Cookies from 'js-cookie';
import ErrorMessage from '../../Form/ErrorMessage';
import { GRC } from 'src/components/Form';
import Select from 'react-select';
import { SentenceSmall } from 'src/components/Typography';
import axios from 'axios';
import { flags } from '../../Icons/Flags';
import { isPossiblePhoneNumber } from 'react-phone-number-input';
import { selectStyle } from 'src/components/Form/elements';
import { useRestoreFormManager } from 'src/utils/RestoreForm';

const FormBlockSchema = Yup.object().shape({
  firstName: Yup.string().required('Champ obligatoire'),
  lastName: Yup.string().required('Champ obligatoire'),
  email: Yup.string()
    .matches(/^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/, 'Email non valide')
    .required('Champ obligatoire'),
  phoneNumber: Yup.string()
    .required('Champ obligatoire')
    .test({
      test: (num) => {
        if (num) {
          if (num.indexOf('+330') !== -1) {
            num = num.replace('+330', '+33');
            return isPossiblePhoneNumber(num);
          } else {
            return isPossiblePhoneNumber(num);
          }
        }
      },
      message: 'Numéro de téléphone non valide',
    }),
  company: Yup.string().required('Champ obligatoire'),
  job: Yup.string().required('Champ obligatoire'),
  description: Yup.string().required('Champ obligatoire'),
  numberOfTrainees: Yup.number().required('Champ obligatoire').positive('Minimum 1 participant'),
  formationId: Yup.string().required('Champ obligatoire'),
  address: Yup.string().required('Champ obligatoire'),
  zipcode: Yup.string().required('Champ obligatoire'),
  city: Yup.string().required('Champ obligatoire'),
});

const FORM_NAME = 'devis-form';
const action = 'Devis';

const FirstBlock = ({ onFormSuccess, defaultSelectedFormation }) => {
  const optionsFormation = [
    { value: 'react-redux', label: 'Formation React Redux' },
    { value: 'react-native', label: 'Formation React Native' },
    { value: 'react-avance', label: 'Formation React Avancé' },
    { value: 'typescript', label: 'Formation TypeScript' },
    { value: 'node-js', label: 'Formation Node.js' },
  ];

  const optionsPeople = [
    { value: 1, label: '1', isDisabled: true },
    { value: 2, label: '2', isDisabled: true },
    { value: 3, label: '3', isDisabled: false },
    { value: 4, label: '4', isDisabled: false },
    { value: 5, label: '5', isDisabled: false },
    { value: 6, label: '6', isDisabled: false },
    { value: 7, label: '7', isDisabled: false },
    { value: 8, label: '8', isDisabled: false },
    { value: 9, label: '9', isDisabled: false },
    { value: 10, label: '10+', isDisabled: false },
  ];
  const manager = useRestoreFormManager();
  const [formError, setFormError] = React.useState(false);
  const [GRCtoken, setGRCToken] = React.useState(null);

  // to access 'formation' field value out of Form
  const [selectedFormation, setSelectedFormation] = React.useState(''); // 'node-js'
  // const [selectedPeople, setSelectedPeople] = React.useState(optionsPeople); // [{},{},]

  const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    phoneNumber: '',
    company: '',
    job: '',
    description: '',
    numberOfTrainees: '',
    formationId: '',
    formationName: '',
    address: '',
    zipcode: '',
    city: '',
    ...(manager.get(FORM_NAME) || {}),
  };

  // set formation field default
  if (defaultSelectedFormation !== null && !selectedFormation) {
    initialValues.formationId = defaultSelectedFormation;
    // console.log('defaultSelectedFormation', defaultSelectedFormation);
    initialValues.formationName = optionsFormation.filter(
      (v) => v.value === defaultSelectedFormation
    )[0].label;
  } else {
    initialValues.formationId = selectedFormation;
  }

  // useEffect(() => {
  //   const copySelectedPeople = [...selectedPeople];
  //   if (
  //     initialValues.formationId &&
  //     initialValues.formationId !== 'react-redux' &&
  //     initialValues.formationId !== 'react-avance'
  //   ) {
  //     copySelectedPeople.map((option) => {
  //       if (option.value < 3) {
  //         option.isDisabled = true;
  //       }
  //     });
  //   } else {
  //     copySelectedPeople.map((option) => {
  //       if (option.value) {
  //         option.isDisabled = false;
  //       }
  //     });
  //   }
  //   setSelectedPeople(copySelectedPeople);
  // }, [initialValues.formationId]);

  // const formationName = optionsFormation.filter((elem) => elem.value);

  return (
    <GRC setGRCToken={setGRCToken} action={action}>
      <Formik
        initialValues={initialValues}
        initialErrors={initialValues}
        validateOnChange={true}
        validationSchema={FormBlockSchema}
        validate={(values) => {
          manager.set(FORM_NAME, values);
        }}
        onSubmit={async (values) => {
          if (!GRCtoken) {
            setFormError(true);
          }
          setFormError(false);
          let {
            firstName,
            lastName,
            email,
            phoneNumber,
            company,
            job,
            description,
            numberOfTrainees,
            formationId,
            formationName,
            address,
            zipcode,
            city,
          } = values;

          try {
            const utmSource = Cookies.get('tracking') || Cookies.get('utm_source') || '';
            const gclid = Cookies.get('_gcl_aw') || '';
            const fbclid = Cookies.get('fbclid') || '';
            const referrer = Cookies.get('referrer') || '';

            const response = await axios.post(
              `${process.env.GATSBY_BASE_URL_NEW_API}/forms/devis`,
              {
                firstName,
                lastName,
                email,
                phoneNumber,
                company,
                job,
                description,
                numberOfTrainees,
                formationId,
                formationName,
                address,
                zipcode,
                city,
                source: document.location.href,
                utmSource,
                gclid,
                fbclid,
                referrer,
                action,
                GRCtoken,
                track: {
                  utmSource: Cookies.get('utm_source') || '',
                  utmMedium: Cookies.get('utm_medium') || '',
                  utmCampaign: Cookies.get('utm_campaign') || '',
                  utmCampaignId: Cookies.get('utm_campaign_id') || '',
                  adGroupName: Cookies.get('adgroup_name') || '',
                  utmAdGroupId: Cookies.get('utm_adgroup_id') || '',
                  utmTerm: Cookies.get('utm_term') || '',
                  matchType: Cookies.get('matchtype') || '',
                  utmContent: Cookies.get('utm_content') || '',
                },
              }
            );
            if (response.data && response.data.message === 'MESSAGE SENT') {
              window.dataLayer.push({
                event: 'courseSelection',
                course: formationId,
              });
              onFormSuccess();
            }
          } catch (error) {
            console.error(error.message);

            setFormError(true);
          }
        }}
      >
        {({ errors, handleChange, touched, isValid, setFieldValue, values, isSubmitting }) => {
          return (
            <Form>
              <div
                css={{
                  display: 'flex',
                  flexDirection: 'column',
                }}
              >
                <TwoInputWrapper>
                  <div>
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Prénom&nbsp;</Label>
                      <SentenceSmall>*</SentenceSmall>
                    </div>
                    <InputForm
                      name="firstName"
                      value={values.firstName}
                      onChange={handleChange}
                      errorStyle={errors.firstName && touched.firstName ? true : false}
                    />
                    <ErrorMessage
                      isVisible={errors.firstName && touched.firstName}
                      message={errors.firstName}
                    />
                  </div>
                  <RightInputWrapper>
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Nom&nbsp;</Label>
                      <SentenceSmall>*</SentenceSmall>
                    </div>
                    <InputForm
                      name="lastName"
                      errorStyle={errors.lastName && touched.lastName ? true : false}
                      value={values.lastName}
                      onChange={handleChange}
                    />
                    <ErrorMessage
                      isVisible={errors.lastName && touched.lastName}
                      message={errors.lastName}
                    />
                  </RightInputWrapper>
                </TwoInputWrapper>
                <TwoInputWrapper padding>
                  <div>
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Email&nbsp;</Label>
                      <SentenceSmall>*</SentenceSmall>
                    </div>
                    <InputForm
                      name="email"
                      type="text"
                      errorStyle={errors.email && touched.email ? true : false}
                      onChange={handleChange}
                      value={values.email}
                    />
                    <ErrorMessage
                      isVisible={errors.email && touched.email}
                      message={errors.email}
                    />
                  </div>
                  <RightInputWrapper>
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Téléphone&nbsp;</Label>
                      <SentenceSmall>*</SentenceSmall>
                    </div>
                    <InputPhone
                      errors={errors}
                      touched={touched}
                      placeholder="Entrez votre numéro"
                      autoComplete="tel"
                      country="FR"
                      defaultCountry="FR"
                      flags={flags}
                      displayInitialValueAsLocalNumber={true}
                      value={values.phoneNumber}
                      onChange={(number) => {
                        setFieldValue('phoneNumber', number);
                      }}
                    />
                    <ErrorMessage
                      isVisible={errors.phoneNumber && touched.phoneNumber}
                      message={errors.phoneNumber}
                    />
                  </RightInputWrapper>
                </TwoInputWrapper>
                <TwoInputWrapper padding>
                  <div>
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Nom de l'entreprise&nbsp;</Label>
                      <SentenceSmall>*</SentenceSmall>
                    </div>
                    <InputForm
                      name="company"
                      errorStyle={errors.company && touched.company ? true : false}
                      onChange={handleChange}
                      value={values.company}
                    />
                    <ErrorMessage
                      isVisible={errors.company && touched.company}
                      message={errors.company}
                    />
                  </div>
                  <RightInputWrapper>
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Fonction&nbsp;</Label>
                      <SentenceSmall>*</SentenceSmall>
                    </div>
                    <InputForm
                      name="job"
                      errorStyle={errors.job && touched.job ? true : false}
                      onChange={handleChange}
                      value={values.job}
                    />
                    <ErrorMessage isVisible={errors.job && touched.job} message={errors.job} />
                  </RightInputWrapper>
                </TwoInputWrapper>
                <TwoInputWrapper padding>
                  <div data-cy="trainingsList">
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Nom de la formation&nbsp;</Label>
                      <SentenceSmall>*</SentenceSmall>
                    </div>
                    <Select
                      styles={selectStyle}
                      name="formationId"
                      isSearchable={true}
                      defaultValue={optionsFormation.find(
                        (option) => option.value === defaultSelectedFormation
                      )}
                      placeholder="Sélectionner..."
                      errors={errors.formationId && touched.formationId ? true : false}
                      onChange={(value) => {
                        setFieldValue('formationName', value.label);
                        setFieldValue('formationId', value.value);
                        setSelectedFormation(value.value);
                      }}
                      options={optionsFormation}
                    />
                    <ErrorMessage
                      isVisible={errors.formationId && touched.formationId}
                      message={errors.formationId}
                    />
                  </div>
                  <RightInputWrapper data-cy="traineesNumber">
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Nombre de participants&nbsp;</Label>
                      <SentenceSmall>*</SentenceSmall>
                    </div>

                    <Select
                      key={initialValues.formationId}
                      styles={selectStyle}
                      name="numberOfTrainees"
                      isSearchable={true}
                      placeholder="Sélectionner..."
                      errors={errors.numberOfTrainees && touched.numberOfTrainees ? true : false}
                      onChange={(value) => {
                        setFieldValue('numberOfTrainees', value.value);
                      }}
                      options={optionsPeople}
                    />
                    <ErrorMessage
                      isVisible={errors.numberOfTrainees && touched.numberOfTrainees}
                      message={errors.numberOfTrainees}
                    />
                  </RightInputWrapper>
                </TwoInputWrapper>
                <div css={{ paddingTop: 45 }}>
                  <div css={{ display: 'flex', flexDirection: 'row' }}>
                    <Label>Adresse&nbsp;</Label>
                    <SentenceSmall>*</SentenceSmall>
                  </div>
                  <InputFormLarge
                    name="address"
                    errorStyle={errors.address && touched.address ? true : false}
                    onChange={handleChange}
                    value={values.address}
                  />
                  <ErrorMessage
                    isVisible={errors.address && touched.address}
                    message={errors.address}
                  />
                </div>

                <TwoInputWrapper padding>
                  <div>
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Code Postal</Label>
                      <SentenceSmall>&nbsp;*</SentenceSmall>
                    </div>
                    <InputForm
                      name="zipcode"
                      errorStyle={errors.zipcode && touched.zipcode ? true : false}
                      onChange={(e) => {
                        const newValue = e.target.value.replace(/[^0-9]/g, '');
                        setFieldValue('zipcode', newValue);
                      }}
                      value={values.zipcode}
                    />
                    <ErrorMessage
                      isVisible={errors.zipcode && touched.zipcode}
                      message={errors.zipcode}
                    />
                  </div>

                  <RightInputWrapper>
                    <div css={{ display: 'flex', flexDirection: 'row' }}>
                      <Label>Ville&nbsp;</Label>
                      <SentenceSmall>*</SentenceSmall>
                    </div>
                    <InputForm
                      name="city"
                      errorStyle={errors.city && touched.city ? true : false}
                      onChange={handleChange}
                      value={values.city}
                    />
                    <ErrorMessage isVisible={errors.city && touched.city} message={errors.city} />
                  </RightInputWrapper>
                </TwoInputWrapper>

                <div css={{ paddingTop: 45 }}>
                  <div css={{ display: 'flex', flexDirection: 'row' }}>
                    <Label>Description de vos besoins&nbsp;</Label>
                    <SentenceSmall>*</SentenceSmall>
                  </div>
                  <Sublabel css={{ maxWidth: 585 }}>
                    Dans le cas où l'un des participants serait en situation de handicap, n'hésitez
                    pas à nous en informer afin que nous vérifiions ensemble comment vous proposer
                    l'accompagnement le plus adapté possible.
                  </Sublabel>
                  <TextareaForm
                    name="description"
                    onChange={handleChange}
                    errorStyle={errors.description && touched.description ? true : false}
                    value={values.description}
                  />
                  <ErrorMessage
                    isVisible={errors.description && touched.description}
                    message={errors.description}
                  />
                </div>

                {/* handicap  */}
                {/* <Label css={{ marginTop: 50 }}>Êtes-vous en situation de handicap ?</Label>
                  <Sublabel>
                    Nous vérifierons ensemble comment vous proposer l'accompagnement le plus adapté
                    possible.
                  </Sublabel>

                  <div css={{ display: 'flex' }}>
                    <MultiSelectSmall
                      isSelected={values.handicap === 'Oui'}
                      onClick={() => {
                        setFieldValue('handicap', values.handicap !== 'Oui' ? 'Oui' : '');
                      }}
                    >
                      Oui
                    </MultiSelectSmall>
                    <MultiSelectSmall
                      isLeft
                      isSelected={values.handicap === 'Non'}
                      onClick={() => {
                        setFieldValue('handicap', values.handicap !== 'Non' ? 'Non' : '');
                      }}
                    >
                      Non
                    </MultiSelectSmall>
                  </div>
                  <ErrorMessage
                    isVisible={errors.handicap && touched.handicap}
                    message={errors.handicap}
                  /> */}

                <div css={{ paddingBottom: 10 }}>
                  <NextBtn
                    type="submit"
                    disabledStyle={isValid === false}
                    disabled={isSubmitting}
                    isFullWidth
                  >
                    Envoyer
                  </NextBtn>
                </div>

                <div css={{ paddingBottom: 10 }}>
                  {formError && (
                    <ErrorMessage
                      isVisible={true}
                      message={
                        GRCtoken
                          ? "Une erreur est survenue. Veuillez nous contacter à l'adresse contact@lereacteur.io"
                          : "Une erreur est survenue ! Vérifiez que vous n'êtes pas derrière un VPN. Si le problème persiste, merci de nous contacter directement."
                      }
                    />
                  )}
                </div>
                <SentenceSmall>* Champ obligatoire</SentenceSmall>
              </div>
            </Form>
          );
        }}
      </Formik>
    </GRC>
  );
};
export default FirstBlock;
